import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid justify-content-start align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "col-2 text-2xl mt-3 mb-0" }, "USERS:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, null, -1)
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = { class: "px-3 my-4 font-bold" }
const _hoisted_6 = { class: "field grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  style: {"width":"100px"}
}, "Name", -1)
const _hoisted_8 = { class: "field grid" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  style: {"width":"100px"}
}, "Password", -1)
const _hoisted_10 = { class: "field grid" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "company",
  style: {"width":"100px"}
}, "Company", -1)
const _hoisted_12 = { class: "field grid" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "role",
  style: {"width":"100px"}
}, "Admin", -1)

import DialogLoader from "@/components/DialogLoader.vue";
import { onMounted, ref } from "vue";
import axios from "axios";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableUsers',
  setup(__props) {

const users = ref([{ RowKey: "", company: "", companyName: "", admin: "" }]);
const companies = ref([]);
const addDialog = ref(false);
const user = ref({ RowKey: "", password: "", company: "", role: "" });
const roles = ref([
  { label: "Admin", value: "admin" },
  { label: "Client", value: "client" },
]);
const showLoader = ref(false);

onMounted(() => {
  getUsers();
});

function getUsers() {
  showLoader.value = true;
  axios
    .get("apiadm/v1/users")
    .then((response) => {
      users.value = response.data;
      getCompanies();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

function getCompanies() {
  axios
    .get("apiadm/v1/companies")
    .then((response) => {
      companies.value = response.data;
      let company = { RowKey: "", name: "" };
      for (const user of users.value) {
        for (company of companies.value) {
          if (user.company === company.RowKey) {
            user.companyName = company.name;
          }
        }
      }
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

function saveUser() {
  showLoader.value = true;
  axios
    .post("apiadm/v1/user", user.value)
    .then((response) => {
      console.log(response);
      getUsers();
      addDialog.value = false;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          label: "Add User",
          icon: "pi pi-plus",
          class: "p-button-success mt-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addDialog.value = true))
        })
      ])
    ]),
    _createVNode(_component_DataTable, {
      value: users.value,
      tableStyle: "min-width: 50rem"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "RowKey",
          header: "Name"
        }),
        _createVNode(_component_Column, {
          field: "companyName",
          header: "company"
        }),
        _createVNode(_component_Column, {
          field: "role",
          header: "Role"
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Dialog, {
      visible: addDialog.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((addDialog).value = $event)),
      header: "Add Company",
      modal: true,
      style: { width: '50vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: user.value.RowKey,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.RowKey) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputText, {
              id: "password",
              type: "password",
              modelValue: user.value.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.password) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Dropdown, {
              id: "company",
              modelValue: user.value.company,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.company) = $event)),
              options: companies.value,
              optionLabel: "name",
              optionValue: "RowKey",
              style: {"width":"250px"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_Dropdown, {
              id: "role",
              modelValue: user.value.role,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.role) = $event)),
              options: roles.value,
              optionLabel: "label",
              optionValue: "value",
              style: {"width":"250px"}
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_Button, {
          label: "Save",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: saveUser
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(DialogLoader, { showLoader: showLoader.value }, null, 8, ["showLoader"])
  ], 64))
}
}

})